export default __webpack_public_path__ + "static/media/ls3_g03.07465652.png";